import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService, AuthService, RouteService } from '@dexio/common';
import { loadProjectModules } from '../../utils/routes';
import { ProjectsService } from '../../services/projects.service';
import { CustomManifest } from '../../utils/config';
import { getManifest } from '@angular-architects/module-federation';

import { RouteService as MenuService } from '@dexio/common';
import { ProjectLoaderService } from '../../services/project-loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit, OnDestroy {
  loaded: boolean = false;
  loadingStatus: string = "";

  constructor(
    private readonly configs: AppConfigService,
    private readonly routes: RouteService,
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly projectService: ProjectsService,
    private readonly menuService: MenuService,
    private readonly projectLoader: ProjectLoaderService
  ) {}

  private lastErrorSubscription: Subscription = new Subscription();
  ngOnInit(): void {
    this.lastErrorSubscription = this.auth.getLastError().subscribe((_: any) => { if (typeof _ === 'string' || _ instanceof String) { this.loadingStatus  = _.toString(); } });

    try {
      this.auth.login(window.location.pathname);
    } catch (e: any) {
      console.error('Error while logging in', e);
    }
    
    console.log('hasLoaded', this.loaded);
    if (!this.loaded) {
      this.loaded = false;

      console.log('running promises checks');
      Promise.all([
        this.checkAuthentication(),
        this.checkConfigurations(),
        this.checkRoutes()
      ])
      .then(_ => {
        console.log('initial checks have passed');
        Promise.all([
          new Promise(function(resolve) { setTimeout(resolve, 1000);}), // force the splash screen for a second
          new Promise((resolve, reject) => this.getProjects()
            .then(async projects => { console.log('resolved projects', projects); await this.getModules(projects); resolve(projects); })
            .catch(function(_: any) { console.error(_); reject(_); }))
        ]).then(s => {
          this.loaded = true;
          sessionStorage.setItem('hasLoaded', 'true');
          this.checkRoute();
        })
        .catch(function(_: any) {
          console.error(_);
        });
      })
      .catch((_: any) => {
        console.error(_);
      });
      // things that could be verified:
      //  configs
      //  modules
      //  authentication
      //  routes
      //  files
    } else {
      this.loaded = true;
    }
  }
  ngOnDestroy(): void {
    if (this.lastErrorSubscription) { this.lastErrorSubscription.unsubscribe(); }
  }

  private checkAuthentication(): Promise<boolean> { 
    console.log('getting auth');
    return new Promise((resolve, reject) => {
      var numberOfChecks = 0;
      var interval = setInterval(() => {
        try {
          
        console.log('checking authentication: within interval');
        if (this.auth.isAuthenticated()) {
          console.log('resolving auth');
          console.log(this.router.url);
          clearInterval(interval);
          resolve(true);
        } else if (this.auth.lastError != '') {
          clearInterval(interval);
          this.loadingStatus = 'iMIS is unavailable';
          reject('Unable to authenticate');
        } else {
          numberOfChecks++;
        }
        if (numberOfChecks > 20) { 
          clearInterval(interval);
          this.loadingStatus = 'There was an issue logging on';
          reject('Unable to authenticate');
        }
        }
        catch(_: any) {
          debugger;
          console.log(_);
        }
      }, 500);
    });
  }
  private checkConfigurations(): Promise<boolean> { 
    console.log('getting configs');
    return new Promise((resolve, reject) => {
      var interval = setInterval(() => {
        console.log('checking configs: within interval');
        if (this.configs.loaded) {
          console.log('resolving configs');
          clearInterval(interval);
          resolve(true);
        }
      }, 500);
    });
  }
  private checkRoutes(): Promise<boolean> { 
    console.log('getting routes');
    return new Promise((resolve, reject) => {
      var subscription = this.routes.get().subscribe((_: any) => {
        
        console.log('loading projects, including menu');
        this.projectLoader.load().then(() =>  {
          console.log('checking routes: within subscription');
          if (_[0].submenu.length > 0) {
            console.log('resolving routes');
            subscription.unsubscribe();
            resolve(true);
          } else {
            loadProjectModules(this.router).then(() => {
              console.log('resolved routes - alt');
              subscription.unsubscribe();
              resolve(true);
            });
          }
        }).catch((_: any) => {
          reject(_);
        });
      });
    });
  }
  private checkRoute() {    
    let redirectUrl = localStorage.getItem('dexio_redirect');
    if (redirectUrl == null) { return; }
    if (redirectUrl.includes('/dexioauth/callback')) { redirectUrl = "/"; }
    localStorage.removeItem('dexio_redirect');
    this.router.navigate([redirectUrl]);
  }
  private getProjects() {
    return new Promise((resolve, reject) => {
      this.projectService.getProjects().subscribe({next: (_: any) => resolve(_), error: (_: any) => { console.error('error getting projects', _); reject(_); }});
      this.projectService.refreshProjects();
    });
  }
  private async getModules(projects: any) {    
    console.log('getting manifest to load modules');
    const options = getManifest<CustomManifest>();
    const entries: any = [];
    console.log('retrieved modules', options);
    await Promise.all(Object.keys(options).map(async key => {
      const entry = options[key];
      entries.push(entry);
    }));
    console.log(entries);
    entries.forEach((entry: any) => {
      var matchingProject = projects.filter((_: any) => _.name == entry.displayName);
      if (matchingProject == null || matchingProject.length == 0) {
        // remove project
        console.log('no access to', entry);
        this.menuService.remove('/projects/' + entry.routePath, '/projects');
        this.menuService.get().subscribe((_: any) => console.log(_));
      }
    });
  }
}
